import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ea06f70"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value"]
const _hoisted_2 = {
  key: 0,
  class: "input-icon"
}

import { withDefaults } from "vue";

interface IProps {
  modelValue: string | number;
  withIcon?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Input',
  props: {
    modelValue: {},
    withIcon: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {





const updateValue = (e: Event) => {
  emit("update:modelValue", (e.target as HTMLInputElement).value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-wrap", { 'with-icon': _ctx.withIcon }])
  }, [
    _createElementVNode("input", _mergeProps({
      class: "input",
      value: _ctx.modelValue,
      onInput: updateValue
    }, _ctx.$attrs), null, 16, _hoisted_1),
    (_ctx.withIcon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})